<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar tab='5'></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form ref='searchForm' inline>
                    <el-form-item label="字典名称">
                        <el-input v-model="searchData.dictName"></el-input>
                    </el-form-item>
                    <el-form-item label="字典编号">
                        <el-input v-model="searchData.dictCode"></el-input>                        
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearch()">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain @click="handleResetSearchField" >重置</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain @click="handleAddNewClick()" >添加</el-button>
                    </el-form-item>
                  </el-form>                
              </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :tableData.sync="dictData"
            :crudApi="crudApi"
            addSuccessMessages="添加数据字典成功"
            editSuccessMessages="编辑数据字典成功"
            deleteSuccessMessages="删除数据字典成功"
            deleteBatchSuccessMessages="批量删除数据字典成功"
          >
            <template slot="result">
                <el-table-column sortable prop="dictName" label="字典名称">
                </el-table-column>
                <el-table-column sortable prop="dictCode" label="字典编号">
                </el-table-column>
                <el-table-column sortable prop="description" label="描述" show-overflow-tooltip>  
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <div class="table-column-operate">
                      <el-button type="text" @click="handleEditClick(scope.row)">
                        编辑
                      </el-button>
                      <el-button type="text" @click="handleShowDictItemClick(scope.row)">
                        字典配置
                      </el-button>
                      <el-button type="text" @click="handleDeleteClick(scope.row)">
                        删除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
            </template>
            <template slot="editForm">
              <el-row>
                <el-col>
                  <el-form-item required label="字典名称" prop="dictName">
                    <el-input type="text" placeholder="请输入字典名称" v-model="addNewOrEditData.dictName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item required label="字典编码" prop="dictCode">
                    <el-input type="text" placeholder="请输入字典编码" v-model="addNewOrEditData.dictCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="col-full">
                  <el-form-item label="描述" prop="description">
                    <el-input type="text" placeholder="请输入描述" v-model="addNewOrEditData.description"></el-input>
                  </el-form-item> 
                </div>
              </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除字典？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>  
    <el-drawer
      :title="'字典列表-'+dictName"
      :visible.sync="dictItemDrawer"
      direction="rtl"
      size="900px"
    >
        <dict-item ref="dictItem" :dictId="dictItemId"></dict-item>
    </el-drawer>
  </div>
</template>

<script>
import dictlist from '@/api/sysmanagement/dictlist';
import LeftBar from '../LeftBar';
import DictItem from './dictitem';

export default {
  components: {
    LeftBar,
    DictItem
  },
  data() {
    return {
      dictData: [],
      dictItemDrawer: false,
      dictItemId: '',
      dictName: '',
      searchData: {
        dictName:'',
        dictCode: ''
      },
      addNewOrEditData: {
        dictName:'',
        dictCode: '',
        description: ''
      },
      crudApi: dictlist,
    }
  },
  methods: {
    handleResetSearchField() {
      this.searchData.dictName = ''
      this.searchData.dictCode = ''

      this.handleSearch();
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleShowDictItemClick(item) {
      this.dictItemId  = item.id;
      this.dictName = item.dictName;
      this.dictItemDrawer = true;
      this.$nextTick(() => this.$refs['dictItem'].handleResetSearchField());
    }
  },
  mounted() {    
    this.handleSearch();  
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 800px;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?7867acea